import script from "./CheckboxSingleFormInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxSingleFormInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__